import craftlab from "../assets/craftlab.png"

export default {
  Meta_Craftlab: {
    name: "Meta Craftlab Pvt. Ltd.",
    role: "Full Stack Developer Intern",
    date: "Jun 24 - Jul 24",
    info: "Developed modules of the web app project the organisation was working on using SvelteKit and Prisma along with other interns.",
    place: "Remote",
    logo: craftlab
  },
};
